import React, { useState, useEffect, useMemo, useRef } from "react";
import { Basic } from "../MenuEngineering/ScatterCharts";
import {
  currencyFormatWithoutDecimal,
  currencyFormatWithAlert,
} from "../../helpers/api_helper";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Table,
  Row,
  Col,
} from "reactstrap";
import {
  POST_MENU_OPTIMIZATION,
  POST_KPI_DASHBOARD,
} from "../../helpers/data_helper";
import { Loader } from "../../Components/Common/Loader";
import { getDateByName, convertDateFormate } from "../../helpers/api_helper";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { Line } from "./LineColumnChart";
import CustomPagination from "../../Components/Common/CustomPagination";
import itemCategory from "../../assets/images/item-category.jpg";
import { useSelector } from "react-redux";

const SellingItemPopup = ({
  currency,
  leftFilter,
  leftCustomDate,
  itemData,
  setshowItemModal,
  showItemModal,
  rightFilter,
  mealPeriod,
  defaultCourse,
  selectedPage,
  recalculate,
}) => {
  const itemsPerPage = 50;
  const [ServersTableArrayAjax, setServersTableArrayAjax] = useState(true);
  const [menuItemAjaxModal, setMenuItemAjaxModal] = useState(true);
  const [modalItemID, setModalItemID] = useState(false);
  const [ServersTableArray, setServersTableArray] = useState([]);
  const [Top_item_Correlation, setTop_item_Correlation] = useState([]);
  const [performance_kpi, setPerformance_kpi] = useState({
    Star: 0,
    CashCow: 0,
    Puzzle: 0,
    Dog: 0,
  });
  const [CorrelationTableMsg, setCorrelationTableMsg] = useState("");
  let [ItemNameArray, setItemNameArray] = useState([]);
  const [menuItemDataModal, setMenuItemDataModal] = useState({
    Courses: [],
    MenuItems: [],
  });
  const [item_revenue_chkcount_daywise, setitem_revenue_chkcount_daywise] =
    useState([]);
  const [item_revenue_chkcount, setitem_revenue_chkcount] = useState([]);
  const [showModelPopup, setShowModelPopup] = useState(false);
  const ShowModelPopupToggle = () => {
    setShowModelPopup(!showModelPopup);
  };
  const [pageCount_ServerTable, setPageCount_ServerTable] = useState(0);
  const [selectedPage_ServerTable, setselectedPage_ServerTable] = useState(0);

  const { courses } = useSelector((state) => ({
    courses: state.Dashboard.filterData.courses || [],
  }));

  const courseColorMap = useMemo(() => {
    const map = new Map();

    courses.forEach((course) => {
      if (course.label) {
        map.set(course.label, {
          bg: course.badge_bg || null,
          text: course.badge_text || null,
        });
      }
    });

    return map;
  }, [courses]);

  /**
   * Get full badge style by label
   */
  const getColorByLabel = (label) => {
    const colorObj = courseColorMap.get(label);

    if (!colorObj || !colorObj.bg) {
      return {
        backgroundColor: "#405189",
        color: "#FFFFFF",
      }; // No color assigned
    }

    return {
      backgroundColor: colorObj.bg,
      color: colorObj.text || "#000000",
    };
  };

  useEffect(() => {
    setModalItemID(itemData.item_id);
    setshowItemModal(true);

    // Clear and set ItemNameArray
    for (let i = ItemNameArray.length - 1; i >= 0; i--) {
      ItemNameArray.splice(i, 1);
    }
    ItemNameArray.push(itemData);

    // Prepare date filter
    let leftFilterData = false;
    if (
      leftFilter.value !== "Custom" ||
      (leftFilter.value === "Custom" && leftCustomDate[0] && leftCustomDate[1])
    ) {
      leftFilterData =
        leftFilter.value === "Custom"
          ? {
              from: convertDateFormate(leftCustomDate[0]),
              to: convertDateFormate(leftCustomDate[1]),
            }
          : getDateByName(leftFilter.value);
    }

    /****** Graph API (60 days) ******/
    if (leftFilterData) {
      postDataAPI({
        dateFilter: leftFilterData,
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.item_revenue_chkcount_op,
        mealPeriod: mealPeriod,
        course: defaultCourse,
        page: selectedPage,
        recalculate: recalculate,
        rightFilter: rightFilter,
        item_id: itemData.item_id,
      }).then((response) => {
        setMenuItemAjaxModal(false);
        if (response.status === "ok") {
          const formattedData = response.data.data.map((item) => ({
            row_dt: item.row_dt || "",
            revenue: Number(item.revenue) || 0,
            chk_count: Number(item.chk_count) || 0,
            avg_check: Number(item.avg_check) || 0, // Add avg_check
          }));
          setitem_revenue_chkcount(formattedData);
        }
      });
    }
    /***** END *****/

    /****** CALL Weekly Item Graph API ******/
    postDataAPI({
      mealPeriod: mealPeriod,
      item_id: itemData.item_id,
      serviceName: POST_KPI_DASHBOARD.serviceName,
      op: POST_KPI_DASHBOARD.item_revenue_chkcount_daywise_op,
    })
      .then((response) => {
        if (response.status === "ok") {
          const weeklyData = response?.data?.data || [];

          // Map the data to match the Line component format
          const formattedWeeklyData = weeklyData.map((item) => {
            const dayName = item.day_of_week || "";
            const revenue = Number(item.avg_revenue || 0 );
            const chkCount = Number( item.avg_items_sold || 0 );
            const avgCheck = Number(item.avg_check || 0);

            return {
              row_dt: dayName.substring(0, 3),
              revenue: revenue,
              chk_count: chkCount,
              avg_check: avgCheck,
            };
          });

          setitem_revenue_chkcount_daywise(formattedWeeklyData);
        } else {
          setitem_revenue_chkcount_daywise([]);
        }
      })
      .catch((error) => {
        console.error("Weekly API Error:", error);
        setitem_revenue_chkcount_daywise([]);
      });
    /***** END *****/

    /****** Server Table API Call *******/
    if (leftFilterData) {
      postDataAPI({
        dateFilter: leftFilterData,
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.item_server_qty_op,
        mealPeriod: mealPeriod,
        course: defaultCourse,
        page: selectedPage_ServerTable,
        recalculate: recalculate,
        rightFilter: rightFilter,
        item_id: itemData.item_id,
      }).then((response) => {
        setServersTableArrayAjax(false);
        if (response.status === "ok") {
          setServersTableArray(response.data.data);
          setPageCount_ServerTable(
            Math.ceil(response.data.totalData / itemsPerPage),
          );
        } else {
          setPageCount_ServerTable(0);
        }
      });
    }
    /***** END *****/

    /***** Correlation Table API Call *****/
    if (leftFilterData) {
      postDataAPI({
        dateFilter: leftFilterData,
        rightFilter: rightFilter,
        mealPeriod: mealPeriod,
        course: defaultCourse,
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.item_correlation_op,
        page: selectedPage,
        recalculate: recalculate,
        item_id: itemData.item_id,
      }).then((response) => {
        setMenuItemAjaxModal(false);
        if (response.status === "ok") {
          setTop_item_Correlation(response.data.data.item_data);
          setCorrelationTableMsg(response.data.data.itmCourseMsg);

          // Set performance KPI data
          if (response.data.data.performance_kpi) {
            const data = response.data.data.performance_kpi;
            setPerformance_kpi({
              Star: data.Star || 0,
              CashCow: data["Cash Cow"] || data.CashCow || 0,
              Puzzle: data.Puzzle || 0,
              Dog: data.Dog || 0,
            });
          }
        }
      });
    }
    /***** END *****/
  }, [
    leftFilter,
    leftCustomDate,
    rightFilter,
    mealPeriod,
    selectedPage,
    ItemNameArray,
    setshowItemModal,
    itemData,
    defaultCourse,
    recalculate,
    selectedPage_ServerTable,
  ]);

  return (
    <>
      <Modal
        className="modal-dialog modal-fullscreen custom-bg"
        isOpen={showItemModal}
        toggle={() => {
          setshowItemModal(false);
        }}
        id="fullscreeexampleModal"
      >
        <ModalHeader className="modal-title justify-content-end">
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setshowItemModal(false);
            }}
            aria-label="Close"
          ></button>
        </ModalHeader>
        <ModalBody>
          <Card>
            <CardBody style={{ overflowY: "auto" }}>
              {/* Single Item Table */}
              <Table className="table-hover table-striped align-middle table-nowrap mb-0">
                <thead>
                  <tr
                    style={{ textAlign: "center", backgroundColor: "#f3f3f9" }}
                  >
                    <th scope="col">Item </th>
                    <th scope="col">Course </th>
                    <th scope="col" className="text-start">
                      Sold
                    </th>
                    <th scope="col">Menu Price </th>
                    <th scope="col">Actualised Price </th>
                    <th scope="col">Item Cost </th>
                    <th scope="col">
                      Item Gross <br /> Profit
                    </th>
                    <th scope="col">Total Cost</th>
                    <th scope="col">Total Sales </th>
                    <th scope="col">Sales Mix %</th>
                    <th scope="col">Revenue Mix %</th>
                    <th scope="col">
                      Contribution <br /> Margin
                    </th>
                    <th scope="col">
                      Profit <br /> Contribution
                    </th>
                    <th scope="col">
                      Popularity <br /> Contribution
                    </th>
                    <th scope="col">
                      Performance <br /> Group
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {(ItemNameArray || []).map((itemData, key) => (
                    <tr key={key} style={{ textAlign: "center" }}>
                      <td>{itemData.name}</td>
                      <td>
                        <span
                          onClick={ShowModelPopupToggle}
                          style={getColorByLabel(itemData.course_name)}
                          className={`badge`}
                        >
                          {itemData.course_name}
                        </span>
                      </td>
                      <td>{itemData.sold}</td>
                      <td>
                        {currencyFormatWithAlert(itemData.sell_price, currency)}
                      </td>
                      <td>
                        {currencyFormatWithAlert(
                          itemData.actualised_price,
                          currency,
                        )}
                      </td>
                      <td>
                        {currencyFormatWithAlert(itemData.item_cost, currency)}
                      </td>
                      <td>
                        {currencyFormatWithAlert(
                          itemData.item_gross_profit,
                          currency,
                        )}
                      </td>
                      <td>
                        {currencyFormatWithAlert(itemData.total_cost, currency)}
                      </td>
                      <td>
                        {currencyFormatWithoutDecimal(
                          itemData.total_sales,
                          currency,
                        )}
                      </td>
                      <td>{itemData.sales_mix + "%"}</td>
                      <td>{itemData.revenueMix + "%"}</td>
                      <td>
                        {currencyFormatWithAlert(
                          itemData.ContributionMargin,
                          currency,
                        )}
                      </td>
                      <td>
                        <span
                          className={`badge badge-soft-${
                            itemData.profit_contribution === "Low"
                              ? "danger"
                              : "success"
                          }`}
                        >
                          {itemData.profit_contribution}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge badge-soft-${
                            itemData.popularity_contribution === "Low"
                              ? "danger"
                              : "success"
                          }`}
                        >
                          {itemData.popularity_contribution}
                        </span>
                      </td>
                      <td>
                        <span
                          onClick={ShowModelPopupToggle}
                          className={`badge bg-${
                            itemData.performance_group === "Plowhorse"
                              ? "warning"
                              : itemData.performance_group === "Dog"
                                ? "danger"
                                : itemData.performance_group === "Cash Cow"
                                  ? "warning"
                                  : itemData.performance_group === "Puzzle"
                                    ? "light text-dark"
                                    : "success"
                          }`}
                        >
                          {itemData.performance_group}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {/* Charts Section */}
              <CardBody>
                {/* 60 Days Chart */}
                <Row className="my-3">
                  <Col lg={12}>
                    <h6 className="mb-3">
                      Items Sold and Revenue (Last 60 Days)
                    </h6>
                    <Line
                      series={item_revenue_chkcount}
                      dataColors='["--vz-primary", "--vz-danger"]'
                      showAvgCheck={true}
                      currency={currency}
                    />
                  </Col>
                </Row>

                {/* Weekly Chart - By Day of Week */}
                <Row className="my-3">
                  <Col lg={12}>
                    <h6 className="mb-3">
                      Weekly Item Revenue and Sales (By Day of Week)
                    </h6>
                    <Line
                      series={item_revenue_chkcount_daywise}
                      dataColors='["--vz-success", "--vz-warning"]'
                      showAvgCheck={true}
                      currency={currency}
                    />
                  </Col>
                </Row>
              </CardBody>

              {/* Performance KPI Boxes */}
              <CardBody>
                <Row className="my-3">
                  <Col lg={12}>
                    <h6 className="mb-3 font-semibold">
                      Performance Group Distribution (Last 60 Days)
                    </h6>
                  </Col>

                  <Col lg={3} md={6} className="mb-3">
                    <div
                      className="border border-green-200 p-3 text-center rounded"
                      style={{ backgroundColor: "#f0fdf4" }}
                    >
                      <h5 fontSize="20px">Star</h5>
                      <div className="text-3xl font-bold text-gray-800">
                        <span
                          style={{ fontSize: "20px", padding: "8px 16px" }}
                        >
                          {performance_kpi.Star || 0}
                        </span>
                      </div>
                    </div>
                  </Col>

                  <Col lg={3} md={6} className="mb-3">
                    <div
                      className="border border-yellow-200 p-3 text-center rounded"
                      style={{ backgroundColor: "#fefce8" }}
                    >
                      <h5 fontSize="20px">
                        Cash Cow
                      </h5>
                      <div className="text-3xl font-bold text-gray-800">
                        <span
                          style={{ fontSize: "20px", padding: "8px 16px" }}
                        >
                          {performance_kpi.CashCow || 0}
                        </span>
                      </div>
                    </div>
                  </Col>

                  <Col lg={3} md={6} className="mb-3">
                    <div
                      className="border border-gray-200 p-3 text-center rounded"
                      style={{ backgroundColor: "#f9fafb" }}
                    >
                      <h5 fontSize="20px">Puzzle</h5>
                      <div className="text-3xl font-bold text-gray-800">
                        <span
                          style={{
                            fontSize: "20px",
                            padding: "8px 16px",
                          }}
                        >
                          {performance_kpi.Puzzle || 0}
                        </span>
                      </div>
                    </div>
                  </Col>

                  <Col lg={3} md={6} className="mb-3">
                    <div
                      className="border border-red-200 p-3 text-center rounded"
                      style={{ backgroundColor: "#fef2f2" }}
                    >
                      <h5 fontSize="20px">Dog</h5>
                      <div className="text-3xl font-bold text-gray-800">
                        <span
                          style={{ fontSize: "20px", padding: "8px 16px" }}
                        >
                          {performance_kpi.Dog || 0}
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>

              {/* Top Item Correlation Table */}
              <h5>Top Item Correlation</h5>
              <h6>
                {" "}
                {CorrelationTableMsg !== ""
                  ? "(" + CorrelationTableMsg + ")"
                  : ""}{" "}
              </h6>
              {Top_item_Correlation && Top_item_Correlation.length > 0 ? (
                <Table className="table-hover table-striped align-middle table-nowrap mb-5">
                  <thead>
                    <tr
                      style={{
                        textAlign: "center",
                        backgroundColor: "#f3f3f9",
                      }}
                    >
                      <th scope="col">Name </th>
                      <th scope="col">Category / Tribe</th>
                      <th scope="col">% Chosen</th>
                      <th scope="col">Performance Group</th>
                      <th scope="col">Item Sold</th>
                      <th scope="col">Revenue</th>
                      <th scope="col">Average Check</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Top_item_Correlation.map((itemData, key) => (
                      <tr key={key} style={{ textAlign: "center" }}>
                        <td>{itemData.item_name}</td>
                        <td>
                          <span
                            onClick={ShowModelPopupToggle}
                            style={getColorByLabel(itemData.cfv_display_name)}
                            className={`badge`}
                          >
                            {itemData.cfv_display_name}
                          </span>
                        </td>
                        <td>{itemData.ref_count} %</td>
                        <td>
                          <span
                            className={`badge bg-${
                              itemData.cat_group === "Plowhorse"
                                ? "warning"
                                : itemData.cat_group === "Dog"
                                  ? "danger"
                                  : itemData.cat_group === "Cash Cow"
                                    ? "warning"
                                    : itemData.cat_group === "Puzzle"
                                      ? "light text-dark"
                                      : "success"
                            }`}
                          >
                            {itemData.cat_group}
                          </span>
                        </td>
                        <td>{itemData.item_sold}</td>
                        <td>
                          {currencyFormatWithAlert(
                            itemData.item_revenue,
                            currency,
                          )}
                        </td>
                        <td>
                          {currencyFormatWithAlert(
                            itemData.avg_check,
                            currency,
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <Table className="table-hover table-striped align-middle table-nowrap mb-5">
                  <thead>
                    <tr
                      style={{
                        textAlign: "center",
                        backgroundColor: "#f3f3f9",
                      }}
                    >
                      <th scope="col">Name </th>
                      <th scope="col">Category / Tribe</th>
                      <th scope="col">% Chosen</th>
                      <th scope="col">Performance Group</th>
                      <th scope="col">Item Sold</th>
                      <th scope="col">Revenue</th>
                      <th scope="col">Average Check</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ textAlign: "center" }}>
                      <td colSpan={7}>No data</td>
                    </tr>
                  </tbody>
                </Table>
              )}

              {/* Servers Table */}
              <h5>Servers</h5>
              {ServersTableArray && ServersTableArray.length > 0 ? (
                <div className="m-3">
                  <div
                    className={
                      ServersTableArrayAjax
                        ? "opacity-0 table-responsive table-card"
                        : "table-responsive table-card"
                    }
                  >
                    <table className="table table-borderless table-centered align-middle table-nowrap mb-0 text-center">
                      <thead className="text-muted table-light">
                        <tr>
                          <th scope="col">Name </th>
                          <th scope="col">Quantity sold as %</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ServersTableArray.map((itemData, key) => (
                          <tr key={key} style={{ textAlign: "center" }}>
                            <td>{itemData.server_name}</td>
                            <td>{itemData.qty_sold_perentage} %</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-4 float-end">
                    <nav>
                      <CustomPagination
                        pageCount={pageCount_ServerTable}
                        setSelectedPage={setselectedPage_ServerTable}
                      />
                    </nav>
                  </div>
                </div>
              ) : (
                <Table className="table-hover table-striped align-middle table-nowrap mb-0">
                  <thead>
                    <tr
                      style={{
                        textAlign: "center",
                        backgroundColor: "#f3f3f9",
                      }}
                    >
                      <th scope="col">Name </th>
                      <th scope="col">Quantity sold as %</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ textAlign: "center" }}>
                      <td colSpan={2}>No data</td>
                    </tr>
                  </tbody>
                </Table>
              )}
            </CardBody>
          </Card>
        </ModalBody>
      </Modal>

      {/* Performance Group Modal */}
      <Modal
        isOpen={showModelPopup}
        toggle={() => {
          ShowModelPopupToggle();
        }}
        centered
      >
        <ModalHeader className="justify-content-end">
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              ShowModelPopupToggle();
            }}
            aria-label="Close"
          ></button>
        </ModalHeader>
        <ModalBody>
          <img src={itemCategory} className="img-fluid" alt="" />
        </ModalBody>
      </Modal>
    </>
  );
};
export default SellingItemPopup;